export const SparklingBriefcase: React.FC<React.HTMLProps<SVGSVGElement>> = (props) => (
  <svg
    width="97"
    height="96"
    viewBox="0 0 97 96"
    fill="none"
    role="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M48.5 90C71.696 90 90.5 71.196 90.5 48C90.5 24.804 71.696 6 48.5 6C25.304 6 6.5 24.804 6.5 48C6.5 71.196 25.304 90 48.5 90Z"
      fill="#C8F8F6"
    />
    <path
      d="M55.802 31.5512L53.2082 32.012C52.967 30.6524 52.0454 29.6708 50.4692 29.093C48.92 28.5248 46.8248 28.4138 44.7218 28.787C40.8236 29.4794 37.1582 31.7552 37.6928 34.7666L35.0984 35.2274C34.4846 31.769 37.0898 27.467 44.261 26.1932C49.205 25.3154 54.926 26.618 55.802 31.5512Z"
      fill="#00A49F"
    />
    <path
      d="M74.6584 60.9728L69.343 31.0376L65.8648 28.6082L24.6364 35.9282C23.6878 37.2866 23.1556 38.048 22.207 39.4064L27.5224 69.3416L31.0006 71.7709L72.229 64.451L74.6584 60.9728Z"
      fill="#00A49F"
    />
    <path
      d="M63.172 50.3282L34.6426 55.394C29.5048 56.306 24.5998 52.8806 23.6872 47.7428L22.207 39.4076L24.6364 35.9294L65.8648 28.6094L69.343 31.0388L70.8232 39.374C71.7352 44.5118 68.3098 49.4168 63.172 50.3294V50.3282Z"
      fill="#23E5DB"
    />
    <path
      d="M51.0162 48.2079L45.3242 49.2185L46.7973 57.5151L52.4893 56.5045L51.0162 48.2079Z"
      fill="#FFCE32"
    />
    <path
      d="M28.1371 17.3218L30.1423 19.327L28.1371 21.3322L26.1319 19.327L28.1371 17.3218ZM28.1371 12.604L21.4141 19.327L28.1371 26.05L34.8601 19.327L28.1371 12.604Z"
      fill="#23E5DB"
    />
    <path
      d="M19.1206 35.6977L13.459 30.0361L19.1206 24.3745L24.7822 30.0361L19.1206 35.6977ZM18.1768 30.0361L19.1206 30.9799L20.0644 30.0361L19.1206 29.0923L18.1768 30.0361Z"
      fill="#FFCE32"
    />
    <path
      d="M80.5889 42.9472L82.5401 44.899L80.5889 46.8508L78.6377 44.899L80.5889 42.9472ZM80.5889 38.23L73.9199 44.899L80.5889 51.568L87.2579 44.899L80.5889 38.23Z"
      fill="#23E5DB"
    />
    <path
      d="M55.8018 76.3771L57.753 78.3289L55.8018 80.2807L53.8506 78.3289L55.8018 76.3771ZM55.8018 71.6599L49.1328 78.3289L55.8018 84.9979L62.4708 78.3289L55.8018 71.6599Z"
      fill="#23E5DB"
    />
    <path
      d="M68.7577 72.8239L70.0189 74.0851L68.7577 75.3463L67.4965 74.0851L68.7577 72.8239ZM68.7577 69.7747L64.4473 74.0851L68.7577 78.3955L73.0681 74.0851L68.7577 69.7747Z"
      fill="#FFCE32"
    />
    <path
      d="M14.0526 57.7885L15.3138 59.0497L14.0526 60.3109L12.7914 59.0497L14.0526 57.7885ZM14.0526 54.7393L9.74219 59.0497L14.0526 63.3601L18.363 59.0497L14.0526 54.7393Z"
      fill="#FFCE32"
    />
    <path
      d="M67.4764 18.0658L68.7376 19.327L67.4764 20.5882L66.2152 19.327L67.4764 18.0658ZM67.4764 15.0166L63.166 19.327L67.4764 23.6374L71.7868 19.327L67.4764 15.0166Z"
      fill="#FFCE32"
    />
  </svg>
);
